import React, { createContext, useContext, useEffect, useMemo } from "react";

/*
    NOTEBOOK usa una unica apariencia: DARK.
    Se conserva el contrato del ThemeContext para no romper componentes del Core,
    pero ya no existe seleccion LIGHT / SYSTEM ni persistencia de preferencias.
*/
const ThemeContext = createContext(undefined);
const DARK_META = { code: "dark", label: "Oscuro" };

export const useTheme = () => {
    const context = useContext(ThemeContext);

    if (context !== undefined) return context;

    return {
        useDataTheme: {
            isLoading: false,
            currentTheme: "dark",
            resolvedTheme: "dark",
            availableThemes: ["dark"],
            availableThemesMeta: [DARK_META],
        },
        call_isDark: () => true,
        call_getThemeMeta: () => DARK_META,
        call_setTheme: () => "dark",
        call_toggleTheme: () => "dark",
        call_refreshTheme: () => "dark",
    };
};

export const ThemeProvider = ({ children }) => {
    useEffect(() => {
        if (typeof document === "undefined") return;
        document.documentElement.setAttribute("data-theme", "dark");
        document.documentElement.setAttribute("data-bs-theme", "dark");
        document.documentElement.style.colorScheme = "dark";
    }, []);

    const value = useMemo(() => ({
        useDataTheme: {
            isLoading: false,
            currentTheme: "dark",
            resolvedTheme: "dark",
            availableThemes: ["dark"],
            availableThemesMeta: [DARK_META],
        },
        call_isDark: () => true,
        call_getThemeMeta: () => DARK_META,
        call_setTheme: () => "dark",
        call_toggleTheme: () => "dark",
        call_refreshTheme: () => "dark",
    }), []);

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
